/* ============================================================
   MXM Phase 1 — custom behaviour
   Everything is null-guarded: this file must never throw on
   pages where a component is absent (the old global.js waitlist
   code threw sitewide — that bug lives here now, fixed).
   ============================================================ */

(function () {
  'use strict';

  /* ---------- analytics: dataLayer + Shopify custom events ---------- */

  function mxmTrack(eventName, data) {
    var payload = data || {};
    try {
      window.dataLayer = window.dataLayer || [];
      var dlEntry = { event: eventName };
      for (var k in payload) if (Object.prototype.hasOwnProperty.call(payload, k)) dlEntry[k] = payload[k];
      window.dataLayer.push(dlEntry);
    } catch (e) {
      /* noop */
    }
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(eventName, payload);
      }
    } catch (e) {
      /* noop */
    }
  }
  window.mxmTrack = mxmTrack;

  function onceKey(key) {
    try {
      if (window.sessionStorage.getItem(key)) return false;
      window.sessionStorage.setItem(key, '1');
      return true;
    } catch (e) {
      return true; // storage unavailable: still fire, just not deduped
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  /* ============================================================
     1. Coming-soon waitlist popup (moved from global.js, guarded)
     ============================================================ */

  function initWaitlistPopup() {
    var button = document.querySelector('.button-cs');
    var popup = document.getElementById('waitlistPopup');
    if (!button || !popup) return;
    var closeBtn = popup.querySelector('.popup-close');

    button.addEventListener('click', function () {
      popup.classList.add('active');
      document.documentElement.classList.remove('prevent-scroll');
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        popup.classList.remove('active');
      });
    }
  }

  /* ============================================================
     2. Product media: swipe tracking (spec §2)
     Fires mxm_media_swipe once per slide index per session.
     ============================================================ */

  function initMediaSwipeTracking() {
    var list = document.querySelector('product-info .product__media-list');
    if (!list) return;
    var productId = list.getAttribute('data-mxm-product-id') || 'unknown';
    var lastIndex = 0;
    var scrollTimer = null;

    list.addEventListener('scroll', function () {
      if (scrollTimer) window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(function () {
        var slide = list.querySelector('.product__media-item');
        if (!slide) return;
        var w = slide.getBoundingClientRect().width;
        if (!w) return;
        var index = Math.round(list.scrollLeft / w);
        if (index === lastIndex) return;
        lastIndex = index;
        if (onceKey('mxm_swipe_' + productId + '_' + index)) {
          mxmTrack('mxm_media_swipe', { product_id: productId, slide_index: index });
        }
      }, 150);
    });
  }

  /* ============================================================
     3. On-body video: play only while on screen (spec §4d)
     ============================================================ */

  function initOnbodyVideo() {
    /* two instances exist per page: the full-bleed block under the mobile
       slider and the grid tile in the desktop gallery. Each breakpoint
       shows one; the observer only ever plays the one on screen. */
    Array.prototype.forEach.call(document.querySelectorAll('.mxm-onbody-video'), initOnbodyVideoFor);
  }

  function initOnbodyVideoFor(wrap) {
    var video = wrap.querySelector('video');
    if (!video) return;

    var tryPlay = function () {
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function () {
          // autoplay with sound refused: fall back to muted playback
          video.muted = true;
          wrap.classList.remove('is-unmuted');
          var pp = video.play();
          if (pp && typeof pp.catch === 'function') pp.catch(function () {});
        });
      }
    };

    var soundBtn = wrap.querySelector('.mxm-onbody-video__sound');
    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        wrap.classList.toggle('is-unmuted', !video.muted);
        soundBtn.setAttribute(
          'aria-label',
          video.muted ? soundBtn.getAttribute('data-label-unmute') : soundBtn.getAttribute('data-label-mute')
        );
        if (!video.muted) tryPlay();
      });
    }

    if (!('IntersectionObserver' in window)) {
      tryPlay();
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            tryPlay();
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.25 }
    );
    io.observe(video);
  }

  /* ============================================================
     4. Mobile sticky Add to Bag (spec §5a)
     ============================================================ */

  function initStickyAtc() {
    var bar = document.getElementById('MXM-StickyATC');
    if (!bar) return;

    var productInfo = document.querySelector('product-info');
    var inlineSubmit = productInfo ? productInfo.querySelector('.product-form__submit') : null;
    var mainForm = document.getElementById(bar.getAttribute('data-form-id'));
    var priceEl = bar.querySelector('.mxm-sticky-atc__price');
    var atcBtn = bar.querySelector('.mxm-sticky-atc__button');
    var sizeBtns = Array.prototype.slice.call(bar.querySelectorAll('.mxm-sticky-atc__size'));
    var variants = [];
    try {
      var dataEl = document.getElementById('MXM-StickyATC-Variants');
      if (dataEl) variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      variants = [];
    }

    /* --- appear once the inline Add to Bag scrolls out of view,
           but never over the footer --- */
    var passedInline = false;
    var footerInView = false;

    function updateVisibility() {
      bar.classList.toggle('is-visible', passedInline && !footerInView);
    }

    /* Scroll-driven rather than IntersectionObserver: IO only reports
       changes in intersection, so a jump that skips straight past the
       button (anchor link, back-navigation restore, fast fling) never
       fired and the bar stayed hidden. One measure per 60ms while
       scrolling is cheap and always reflects the current position. */
    var footerEnd =
      document.querySelector('.footer__content-bottom') || document.querySelector('.footer');
    var ticking = false;

    function evaluatePosition() {
      ticking = false;
      /* Show as soon as the shopper starts scrolling (client request), not
         only after the inline Add to Bag has fully scrolled off the top — on
         this PDP the inline button sits below the gallery + on-body video, so
         the old "passed the inline button" trigger only fired ~75% down the
         page. We still hide the bar while the real inline button is on screen
         (so there aren't two Add to Bag buttons at once) and over the footer. */
      var scrolled = window.scrollY || document.documentElement.scrollTop || 0;
      var inlineInView = false;
      if (inlineSubmit) {
        var btnRect = inlineSubmit.getBoundingClientRect();
        inlineInView = btnRect.top < window.innerHeight && btnRect.bottom > 0;
      }
      passedInline = scrolled > 120 && !inlineInView;
      if (footerEnd) {
        /* the copyright row, not the whole footer: on a product with no
           recommendations the footer top enters the viewport ~100px after
           the button leaves it, which never gave the bar a chance */
        var footRect = footerEnd.getBoundingClientRect();
        footerInView = footRect.top < window.innerHeight && footRect.bottom > 0;
      }
      updateVisibility();
    }

    function requestEvaluate() {
      if (ticking) return;
      ticking = true;
      window.setTimeout(evaluatePosition, 60);
    }

    if (inlineSubmit) {
      window.addEventListener('scroll', requestEvaluate, { passive: true });
      window.addEventListener('resize', requestEvaluate);
      evaluatePosition();
    }

    /* --- helpers --- */
    function currentVariantId() {
      if (!mainForm) return null;
      var idInput = mainForm.querySelector('input[name="id"], select[name="id"]');
      return idInput ? String(idInput.value) : null;
    }

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function findVariantByOption(optionValue) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].option_value) === String(optionValue)) return variants[i];
      }
      return null;
    }

    function applySelection(v) {
      if (!v) return;
      if (priceEl && v.price_formatted) priceEl.textContent = v.price_formatted;
      sizeBtns.forEach(function (btn) {
        var on = btn.getAttribute('data-value') === v.option_value;
        btn.classList.toggle('is-selected', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (atcBtn) {
        atcBtn.disabled = !v.available;
        atcBtn.textContent = v.available ? atcBtn.getAttribute('data-label-add') : atcBtn.getAttribute('data-label-soldout');
      }
    }

    function syncFromMain() {
      applySelection(findVariant(currentVariantId()));
    }

    /* --- sticky size tap: pick the size WITHOUT triggering Dawn's variant
       change. Going through the picker re-rendered the buy box and re-focused
       the variant input, which scrolled the off-screen buy box into view and
       yanked the page away from the sticky bar (client-reported). Instead we
       update the bar and set the size on the main picker silently: check the
       radio for its visual state and write the variant id straight into the
       form the sticky button submits. No change event, so no re-render and no
       scroll, and the sticky Add to Bag still adds the chosen size through
       Dawn's product form (which opens the cart drawer). --- */
    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('is-unavailable')) return;
        var value = btn.getAttribute('data-value');
        var v = findVariantByOption(value);
        if (v) applySelection(v);
        var picker = document.querySelector('product-info variant-selects');
        if (picker) {
          var radio = picker.querySelector('input[type="radio"][value="' + CSS.escape(value) + '"]');
          if (radio && !radio.checked) radio.checked = true;
        }
        if (v && mainForm) {
          var idInput = mainForm.querySelector('input[name="id"]');
          if (idInput) idInput.value = v.id;
        }
        mxmTrack('mxm_size_select', { source: 'sticky_bar', size: value });
      });
    });

    /* --- main picker changes reflect back into the bar --- */
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function () {
        window.setTimeout(syncFromMain, 50);
      });
    }
    document.addEventListener('change', function (evt) {
      if (evt.target && evt.target.closest && evt.target.closest('variant-selects')) {
        window.setTimeout(syncFromMain, 150);
        var v = evt.target.value;
        if (v) mxmTrack('mxm_size_select', { source: 'main_picker', size: v });
      }
    });

    /* --- mirror the inline button's disabled state (sold out etc.) --- */
    if (inlineSubmit && 'MutationObserver' in window) {
      var mo = new MutationObserver(syncFromMain);
      mo.observe(inlineSubmit, { attributes: true, attributeFilter: ['disabled'] });
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        mxmTrack('mxm_sticky_atc_click', { product_id: bar.getAttribute('data-product-id') });
      });
    }

    syncFromMain();
  }

  /* ============================================================
     5. Accordions: open tracking (spec §2 / §6)
     ============================================================ */

  function initAccordionTracking() {
    var accordions = document.querySelectorAll('.mxm-accordion');
    if (!accordions.length) return;
    Array.prototype.forEach.call(accordions, function (details) {
      details.addEventListener('toggle', function () {
        if (details.open) {
          mxmTrack('mxm_accordion_open', { accordion: details.getAttribute('data-mxm-accordion') || 'unknown' });
        }
      });
    });
  }

  /* ============================================================
     6. Size chart modal (spec §6)
     Backdrop tap + Escape close, focus trapped, focus returned.
     ============================================================ */

  function initSizeChartModal() {
    var modal = document.getElementById('MXM-SizeChartModal');
    if (!modal) return;

    /* The modal is authored inside the product info column, whose wrapper
       carries Dawn's scroll-in transform. A transformed ancestor becomes the
       containing block for position:fixed, which pinned the modal inside the
       column instead of the viewport. Portal it to <body> so it is always
       measured against the viewport. */
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    var panel = modal.querySelector('.mxm-modal__panel');
    var closeBtn = modal.querySelector('.mxm-modal__close');
    var lastTrigger = null;

    /* the Size Chart row starts hidden; reveal it only once the EastsideCo
       app has actually injected a chart for this product (polls briefly,
       since the app script loads async) */
    var chartRow = document.querySelector('[data-mxm-size-chart-row]');
    /* the Size Guide links beside the size picker and in the sticky bar follow
       the same rule: only shown once we know this product actually has a chart */
    var chartLinks = document.querySelectorAll('[data-mxm-size-chart-link]');
    if (chartRow || chartLinks.length) {
      var attempts = 0;
      var poll = window.setInterval(function () {
        attempts += 1;
        if (modal.querySelector('.esc-size-guide')) {
          if (chartRow) chartRow.removeAttribute('hidden');
          Array.prototype.forEach.call(chartLinks, function (el) {
            el.removeAttribute('hidden');
          });
          window.clearInterval(poll);
        } else if (attempts > 20) {
          window.clearInterval(poll); // no chart for this product: stays hidden
        }
      }, 500);
    }

    function focusables() {
      return panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    }

    function open(trigger) {
      lastTrigger = trigger || null;
      modal.classList.add('is-open');
      modal.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus();
      // only advertise sideways scrolling when the table really overflows.
      // re-checked over ~1s because the size-guide app can reflow its table
      // after the modal opens, and again on resize/rotate.
      var body = modal.querySelector('.mxm-modal__body');
      if (body) {
        var check = function () {
          modal.classList.toggle('has-x-overflow', body.scrollWidth > body.clientWidth + 2);
        };
        [0, 150, 400, 900].forEach(function (d) { window.setTimeout(check, d); });
        if ('ResizeObserver' in window && !body.__mxmRo) {
          body.__mxmRo = new ResizeObserver(check);
          body.__mxmRo.observe(body);
        }
      }
      mxmTrack('mxm_size_chart_open', {});
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    document.addEventListener('click', function (evt) {
      var trigger = evt.target.closest ? evt.target.closest('.mxm-size-chart-trigger') : null;
      if (trigger) {
        evt.preventDefault();
        open(trigger);
      }
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    modal.addEventListener('click', function (evt) {
      if (evt.target === modal) close(); // backdrop tap
    });

    document.addEventListener('keydown', function (evt) {
      if (!modal.classList.contains('is-open')) return;
      if (evt.key === 'Escape') {
        close();
        return;
      }
      if (evt.key === 'Tab') {
        var items = focusables();
        if (!items.length) return;
        var first = items[0];
        var last = items[items.length - 1];
        if (evt.shiftKey && document.activeElement === first) {
          evt.preventDefault();
          last.focus();
        } else if (!evt.shiftKey && document.activeElement === last) {
          evt.preventDefault();
          first.focus();
        }
      }
    });
  }

  /* ============================================================
     7. Cart drawer: view_cart / remove_from_cart + cross-sell
     (spec §2 / §7)
     ============================================================ */

  function cartItemsFromJson() {
    try {
      var el = document.getElementById('MXM-CartData');
      if (!el) return [];
      return JSON.parse(el.textContent).items || [];
    } catch (e) {
      return [];
    }
  }

  function initCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    /* --- view_cart when the drawer opens --- */
    var wasActive = drawer.classList.contains('active');
    var mo = new MutationObserver(function () {
      var isActive = drawer.classList.contains('active');
      if (isActive && !wasActive) {
        var items = cartItemsFromJson();
        mxmTrack('view_cart', {
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
          items: items
        });
        renderCrossSell();
      }
      wasActive = isActive;
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    /* --- remove_from_cart via the drawer's remove buttons --- */
    document.addEventListener('click', function (evt) {
      var removeBtn = evt.target.closest ? evt.target.closest('cart-drawer cart-remove-button') : null;
      if (!removeBtn) return;
      var index = parseInt(removeBtn.getAttribute('data-index'), 10);
      var items = cartItemsFromJson();
      var item = items[index - 1];
      mxmTrack('remove_from_cart', {
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
        items: item ? [item] : []
      });
    });
  }

  /* --- cross-sell: merchant-curated complementary products ---
     Source: Shopify Search & Discovery "complementary" intent for
     the first item in the cart. Renders nothing when the merchant
     has not curated anything (or nothing curated is in stock). */

  var crossSellBusy = false;

  function formatMoney(cents) {
    try {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function renderCrossSell() {
    var container = document.getElementById('MXM-CrossSell');
    if (!container || crossSellBusy) return;
    var items = cartItemsFromJson();
    if (!items.length) {
      container.hidden = true;
      return;
    }
    var inCartIds = items.map(function (i) {
      return i.product_id;
    });
    var firstProductId = inCartIds[0];
    if (!firstProductId) {
      container.hidden = true;
      return;
    }

    crossSellBusy = true;
    fetch('/recommendations/products.json?product_id=' + firstProductId + '&limit=6&intent=complementary')
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .then(function (data) {
        var products = (data.products || []).filter(function (p) {
          return p.available && inCartIds.indexOf(p.id) === -1;
        });
        var list = container.querySelector('.mxm-crosssell__list');
        if (!products.length || !list) {
          container.hidden = true;
          return;
        }
        list.innerHTML = products
          .slice(0, 4)
          .map(function (p) {
            var img = p.featured_image || (p.images && p.images[0]) || '';
            var variant = null;
            for (var i = 0; i < (p.variants || []).length; i++) {
              if (p.variants[i].available) {
                variant = p.variants[i];
                break;
              }
            }
            if (!variant) return '';
            return (
              '<li class="mxm-crosssell__item">' +
              '<a href="' + p.url + '"><img src="' + img + '&width=360" alt="" loading="lazy" width="180" height="240"></a>' +
              '<a class="mxm-crosssell__title" href="' + p.url + '">' + p.title + '</a>' +
              '<span class="mxm-crosssell__price">' + formatMoney(p.price) + '</span>' +
              '<button type="button" class="mxm-crosssell__add" data-variant-id="' + variant.id + '">Add</button>' +
              '</li>'
            );
          })
          .join('');
        container.hidden = false;
      })
      .catch(function () {
        container.hidden = true;
      })
      .finally(function () {
        crossSellBusy = false;
      });
  }

  /* quick add from the cross-sell rail, then re-render the drawer */
  function initCrossSellAdd() {
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest ? evt.target.closest('.mxm-crosssell__add') : null;
      if (!btn) return;
      btn.disabled = true;
      var body = {
        items: [{ id: parseInt(btn.getAttribute('data-variant-id'), 10), quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      };
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          return r.json();
        })
        .then(function (response) {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.renderContents === 'function' && response.sections) {
            drawer.renderContents(response);
          } else {
            window.location.reload();
          }
          mxmTrack('add_to_cart', { source: 'cart_crosssell', variant_id: btn.getAttribute('data-variant-id') });
          window.setTimeout(renderCrossSell, 400);
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  }

  /* ============================================================
     8. select_item: product card clicks in collection grids
     ============================================================ */

  function initSelectItemTracking() {
    document.addEventListener('click', function (evt) {
      var link = evt.target.closest ? evt.target.closest('.card-wrapper a[href*="/products/"]') : null;
      if (!link) return;
      var card = link.closest('.card-wrapper');
      var heading = card ? card.querySelector('.card__heading') : null;
      mxmTrack('select_item', {
        item_name: heading ? heading.textContent.trim() : '',
        item_url: link.getAttribute('href')
      });
    });
  }

  /* ============================================================
     boot
     ============================================================ */

  ready(function () {
    initSelectItemTracking();
    initWaitlistPopup();
    initMediaSwipeTracking();
    initOnbodyVideo();
    initStickyAtc();
    initAccordionTracking();
    initSizeChartModal();
    initCartDrawer();
    initCrossSellAdd();
  });
})();
